'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var CalendarWeek = {};

exports.__exports = CalendarWeek;
